var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":"","disabled":_vm.isDateAvailable && _vm.isRoomAvailable,"max-width":"300"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({},'div',attrs,false),on),[_c('v-btn',{staticClass:"primary-gradient",attrs:{"disabled":!_vm.isDateAvailable || !_vm.isRoomAvailable,"block":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.$emit('start-reservation')}}},[_vm._v("\n        "+_vm._s(_vm.reservationMethod.callToAction)+"\n      ")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.isDateAvailable
      ? _vm.$t('activity_reservation.warning.reservation_method_no_room')
      : !_vm.validBookings
        ? _vm.$t('activity_reservation.warning.no_checkin_or_checkout')
        : _vm.lastValidDate
          ? _vm.$t('activity_reservation.warning.reservation_method_first_date', {
              date: _vm.moment(_vm.firstValidDate).format('L'),
              hour: _vm.moment(_vm.firstValidDate).format('HH:mm')
            })
          : _vm.$t('activity_reservation.warning.no_booking')))])])}
var staticRenderFns = []

export { render, staticRenderFns }